<template lang="pug">
  include /mixins.pug
  +b.gallery__content
    +b.PICTURE.image-wrapper(@click.prevent="openVideoModal")
      +e.SOURCE.source(
        type="image/webp"
        :srcset="item[galleryMap[index].webp]"
      )
      +e.IMG.item.--pointer-none(
        :src="item[galleryMap[index].common]"
      )
    +e.icon.--play
      +b.I.icon.--type_play
</template>

<script>

export default {
  name: 'GalleryVideoOpener',
  props: {
    item: {},
    index: {},
    galleryMap: {},
  },
  methods: {
    openVideoModal() {
      const modal = () => import('@components/Modals/Video')
      this.$modal.show(modal, {
        video: this.item.video,
      }, {
        class: 'v--modal-xl',
      })
    },
  },
}
</script>
